import * as R from "ramda";
import React, { useEffect, useState, useRef } from "react";

import { isFunction } from "@/util";

export const MainContainer = (props) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const ref = useRef(null);

  const paddingBottom = 20;

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const refTop = ref.current.getBoundingClientRect().top;
    const handleResize = () => {
      //  这儿的10是为了避免滚动条
      setWindowHeight(window.innerHeight - refTop - paddingBottom - 10);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref]);

  const children = R.propOr([], "children", props);
  if (!isFunction(children)) {
    return (
      <div
        ref={ref}
        className={`w-full ${props.className || ""}`}
        {...props}
        style={{
          minHeight: windowHeight,
          paddingBottom: paddingBottom,
          ...props.style,
        }}
      />
    );
  }

  return (
    <div
      ref={ref}
      className={`w-full ${props.className || ""}`}
      style={{
        minHeight: windowHeight,
        paddingBottom: paddingBottom,
        ...props.style,
      }}
    >
      {/* 这儿是为了避免内部产生滑动 */}
      {children({ height: windowHeight - paddingBottom })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/MainContainer/main-container.js